// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IValidatePhoneRequest,
  TValidatePhoneModel,
  IMappers,
  TValidatePhoneResponse,
  IValidatePhoneResponse,
  IValidatePhoneResponseError,
} from './types';

export const defaultConfig: TValidatePhoneModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v1/validate-phone/',
  requestType: 'json',
} as TValidatePhoneModel;

export function createValidatePhoneModel(parameters: IValidatePhoneRequest): TValidatePhoneModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IValidatePhoneOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IValidatePhoneRequest;
}

export async function fetchValidatePhone<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IValidatePhoneOptions<TResponse200, TResponse400>): Promise<TValidatePhoneResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createValidatePhoneModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IValidatePhoneResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IValidatePhoneResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TValidatePhoneResponse;
}
